/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkDto
 */
export interface LinkDto {
    /**
     * The title.
     * @type {string}
     * @memberof LinkDto
     */
    title: string;
    /**
     * The URL of the link.
     * @type {string}
     * @memberof LinkDto
     */
    url: string;
}

/**
 * Check if a given object implements the LinkDto interface.
 */
export function instanceOfLinkDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function LinkDtoFromJSON(json: any): LinkDto {
    return LinkDtoFromJSONTyped(json, false);
}

export function LinkDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': json['title'],
        'url': json['url'],
    };
}

export function LinkDtoToJSON(value?: LinkDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'url': value.url,
    };
}

